<template>
  <v-container fluid class="pa-0">
    <div class="breadcrumbs"></div>
    <PageTitle pageHeading="Settings" :rightsideButton="false"> </PageTitle>
    <v-row>
      <!-- <v-col cols="12" md="3" class="pb-0">
        <v-card
          height="100%"
          class="mx-auto d-flex justify-center overflow-hidden"
          color="#F0F0F0"
          elevation="0"
        >
          <v-navigation-drawer
            permanent
            class="setting-left-navigation mt-5"
            width="80%"
          >
            <v-list nav>
              <div
                v-for="item in settingLeftNav"
                :key="item.title"
                link
                class="my-6"
              >
                <v-btn
                  text
                  class="setting-titles-btn font-weight-bold body-2"
                  :class="item.active ? 'active-btn' : ''"
                  left
                  block
                  large
                  @click="scrollToSection(item.id, item.title)"
                >
                  <span class="secondary--font">
                    {{ item.title }}
                  </span></v-btn
                >
              </div>
            </v-list>
          </v-navigation-drawer>
        </v-card>
      </v-col> -->
      <v-col cols="12" class="setting-right-section pr-10">
        <v-row
          v-for="item in settingList"
          :key="item.title"
          class="mb-10 mt-6"
          :ref="item.ref"
          :id="item.id"
        >
          <v-col cols="12" class="my-2 mb-4">
            <h6 class="text-h6 font-weight-medium-custom">
              <span class="black--text secondary--font">{{ item.title }} </span>
            </h6>
          </v-col>
          <v-col
            cols="12"
            md="4"
            v-for="subitem in item.subItems"
            :key="subitem.name"
          >
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card
                :to="{ name: subitem.link }"
                :elevation="hover ? 5 : 1"
                :class="{ 'on-hover': hover }"
                class="pa-4"
                hover
                :disabled="isDisabled(subitem)"
              >
                <v-card-text class="d-flex pa-2">
                  <v-icon color="#03B6FC"> {{ subitem.icon }} </v-icon>
                  <h4 class="body-1 font-weight-medium-custom pl-4">
                    <span class="black--text secondary--font">
                      {{ subitem.name }}
                    </span>
                  </h4>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageTitle from "@/components/shared/PageTitle.vue";
export default {
  name: "SettingView",
  components: {
    PageTitle,
  },
  data: () => {
    return {
      // settingLeftNav: [
      //   { title: "Teams", active: true, id: "teams-section" },
      //   { title: "Workflow", active: false, id: "workflow-section" },
      //   { title: "Channels", active: false, id: "channels-section" },
      //   { title: "Integrations", active: false, id: "integrations-section" },
      // ],
      settingList: [
        // {
        //   title: "Teams",
        //   ref: "teams",
        //   id: "teams-section",
        //   subItems: [
        //     {
        //       name: "Agents",
        //       icon: "mdi-face-agent",
        //       link: "",
        //       disabled: true,
        //     },
        //     {
        //       name: "Groups",
        //       icon: "mdi-account-group",
        //       link: "groups",
        //       disabled: true,
        //     },
        //     {
        //       name: "Roles",
        //       icon: "mdi-account-star",
        //       link: "",
        //       disabled: true,
        //     },
        //     {
        //       name: "Service Hours",
        //       icon: "mdi-clock",
        //       link: "service-hours",
        //       disabled: true,
        //     },
        //     {
        //       name: "Agent Shifts",
        //       icon: "mdi-history",
        //       link: "",
        //       disabled: true,
        //     },
        //   ],
        // },
        {
          title: "Workflow",
          ref: "workflow",
          id: "workflow-section",
          subItems: [
            // {
            //   name: "SLA policies",
            //   icon: "mdi-timer-sand-complete",
            //   link: "",
            //   disabled: true,
            // },
            // {
            //   name: "Email Notification",
            //   icon: "mdi-email-alert",
            //   link: "",
            //   disabled: true,
            // },
            // {
            //   name: "Rules & Triggers",
            //   icon: "mdi-gavel",
            //   link: "",
            //   disabled: true,
            // },
            {
              name: "Reply Templates",
              icon: "mdi-checkbook",
              link: "reply-templates",
              disabled: false,
            },
            {
              name: "Ticket Types",
              icon: "mdi-bookmark-multiple",
              link: "ticket-type",
              disabled: false,
            },
            {
              name:"Tags",
              icon:"mdi-tag",
              link:"tags",
              disabled:false,
            }
          ],
        },
        {
          title: "Channels",
          ref: "channels",
          id: "channels-section",
          subItems: [
            {
              name: "Support Email",
              icon: "mdi-email-open",
              link: "support-emails",
              disabled: false,
            },
            // {
            //   name: "Webstore",
            //   icon: "mdi-id-card",
            //   link: "",
            //   disabled: true,
            // },
          ],
        },
        // {
        //   title: "Integrations",
        //   ref: "integrations",
        //   id: "integrations-section",
        //   subItems: [
        //     {
        //       name: "Commerce Cloud",
        //       icon: "mdi-cart",
        //       link: "",
        //       disabled: true,
        //     },
        //   ],
        // },
      ],
    };
  },
  created() {
    /** added class for setting page to stop page scroll */
    var elements = document.getElementsByClassName("page-section");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("setting-page");
    }
  },
  destroyed() {
    /** removing class from this page */
    var elements = document.getElementsByClassName("page-section");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.remove("setting-page");
    }
  },
  methods: {
    /** apply active color to clicked tab */
    // activeCurrentbtn(currentTitle) {
    //   this.settingLeftNav.map((item) => {
    //     if (item.title == currentTitle) {
    //       item.active = true;
    //     } else {
    //       item.active = false;
    //     }
    //   });
    // },

    /** onclick of perticular tab scroll to respective section */
    scrollToSection(id, title) {
      let elem = document.getElementById(id);
      elem.scrollIntoView();
      // this.activeCurrentbtn(title);
    },
    isDisabled(subitem) {
      if (subitem.name === 'Support Email') {
        return !this.$can('create', 'supportEmail');
      } else if(subitem.name != 'support Email') {
        return !this.$can('create', 'tickets');
      } else {
        return subitem.disabled;
      }
    },
  },
};
</script>

<style lang="scss">
.setting-left-navigation {
  background-color: #f0f0f0 !important;
  .v-navigation-drawer__border {
    width: 0px !important;
  }
}
.setting-titles-btn {
  justify-content: left !important;
}
.active-btn::before {
  opacity: 0.08 !important;
}
.setting-page {
  overflow: hidden !important;
}
.setting-right-section {
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(100vh - 150px) !important;
}
@media only screen and (max-width: 960px) {
  .setting-page {
    // overflow: auto !important;
  }
}
</style>
